import React, { useEffect } from "react";
import { Col, Row, Container } from "react-bootstrap";
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";
import SvgIcon from '@material-ui/core/SvgIcon';
import AffordableIcon from '../../../../icons/affordable.svg';
import FastIcon from '../../../../icons/fast.svg';
import EasyIcon from '../../../../icons/easy.svg';

const useStyles = makeStyles(theme => ({
  textcolor: {
    color: theme.palette.primary.main,
  }
}));

const categories = [
  {
    icon: EasyIcon,
    title: "Easy",
    description: "No medical exam",
  },
  {
    icon: AffordableIcon,
    title: "Affordable",
    description: "Competitive Prices",
  },
  {
    icon: FastIcon,
    title: "Fast",
    description: "Coverage in 15 minutes",
  },
]

export default function GettingStarted(props) {
  const classes = useStyles()

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <Container>
      <Row className="justify-content-center">
        <Col lg={10} className="getting-started">
          <Row className="heroImage">
          </Row>
          <Row className="text-center category">
            {categories.map((item, index) =>
              <Col className="category-item" key={index}>
                <div className="category-icon">
                  <SvgIcon component={item.icon} color="primary" />
                </div>
                <div className="category-text">
                  <h6 className="mb-0 category-title">{item.title}</h6>
                  <p className="category-desc">{item.description}</p>
                </div>
              </Col>
            )}
          </Row>
          <Row className="text-center mt-3">
            <Col>
              <h3>Relax. We've got you covered.</h3>
              <p className="category-desc">Here's what to expect from your<span className={classes.textcolor}> DECREASING TERM </span> process</p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col className="col-auto steps-section">
              <div className="steps-container">
                <div className="step">
                  <div><span className={`step-number ${classes.textcolor}`}>1</span></div>
                  <div className="step-text">Provide basic personal information</div>
                </div>
                <div className="step">
                  <div><span className={`step-number ${classes.textcolor}`}>2</span></div>
                  <div className="step-text">Review your personalized offer with no obligation</div>
                </div>
                <div className="step">
                  <div><span className={`step-number ${classes.textcolor}`}>3</span></div>
                  <div className="step-text">Accept offer and purchase your policy</div>
                </div>
                <div className="step">
                  <div><span className={`step-number ${classes.textcolor}`}>4</span></div>
                  <div className="step-text">Policy Coverage Decreases with coverage need</div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center pb-1 mt-3">
            <span><h6 className={`mb-0 ${classes.textcolor}`}>Ready? Let's get started </h6></span>
          </Row>
          <Row className="justify-content-center mt-4 mb-3">
            <Col className="col-auto">
              <Button variant="outlined" color="primary" onClick={props.onBack} >Back</Button>
              <Button className="ml-4" variant="contained" color="primary" onClick={props.onNext} >Continue</Button>
            </Col>
          </Row>
        </Col>
      </Row>

    </Container>
  )
}

GettingStarted.propTypes = {
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Americo/steps/GettingStarted.js